module.exports = __webpack_public_path__ + "img/icon_share.f12b063c.png";